const getImageNewOriginal = 'https://storage.yandexcloud.net/voting/img'
const getImageNew         = 'https://storage.yandexcloud.net/voting'


const getImageLink = ({ imageId, w, h, original }) => {
  if (imageId) {
    if (original) {
      return `${getImageNewOriginal}/${imageId}`
    }

    return `${getImageNew}/${imageId}/${h ? `h${h}` : `w${w || 500}`}`
    // return `${getImage}?imageId=${imageId}`
  }

  return imageId
}


export default getImageLink
